import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl" }
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = {
  class: "_fw-n",
  "data-qa": "project-stretch-goals-unlocked"
}
const _hoisted_4 = { "data-qa": "project-stretch-goals-box" }
const _hoisted_5 = {
  class: "_mb-6",
  "data-qa": "project-stretch-goals-list:Locked"
}
const _hoisted_6 = { class: "gfu-hd gfu-hd--h3 _ttu _mb-3" }
const _hoisted_7 = {
  key: 0,
  "data-qa": "project-stretch-goals-list:Unlocked"
}
const _hoisted_8 = { class: "gfu-hd gfu-hd--h3 _ttu _mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_stretch_goals_list = _resolveComponent("project-stretch-goals-list")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      ref: "anchor",
      class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider _mb-6",
      "data-qa": `project-description-section-title:${$props.header}`
    }, [
      _createTextVNode(_toDisplayString($props.header) + " ", 1 /* TEXT */),
      _createElementVNode("span", _hoisted_3, _toDisplayString($options.unlockedStretchGoalsText), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.Resources.ProjectHome.StretchGoalsNextHeader), 1 /* TEXT */),
        _createVNode(_component_project_stretch_goals_list, {
          "stretch-goals": $options.lockedStretchGoals,
          "currency-symbol": $props.currencySymbol,
          "placeholder-text": "No new stretch goals to unlock.",
          "data-qa": "project-stretch-goals-list:PlaceholderText"
        }, null, 8 /* PROPS */, ["stretch-goals", "currency-symbol"])
      ]),
      ($options.shouldDisplayAlreadyUnlockedSection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.Resources.ProjectHome.StretchGoalsUnlockedHeader), 1 /* TEXT */),
            _createVNode(_component_project_stretch_goals_list, {
              "stretch-goals": $options.unlockedStretchGoals,
              "currency-symbol": $props.currencySymbol,
              "placeholder-text": `No stretch goals unlocked yet.`,
              "data-qa": "project-stretch-goals-list:PlaceholderText"
            }, null, 8 /* PROPS */, ["stretch-goals", "currency-symbol"])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}